export default {
  URL: process.env.URL || "http://localhost:3000",
  GITHUB_CLIENT_ID: process.env.GITHUB_CLIENT_ID,
  GITHUB_AUTHORIZE_URL: process.env.GITHUB_AUTHORIZE_URL,
  GITHUB_GRAPHQL_ENDPOINT: process.env.GITHUB_GRAPHQL_ENDPOINT,
};
